import { AbstractPlugin } from '../plugin';

export class InteractLoader extends AbstractPlugin {
}
